var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombined({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1366,
    height: 650,
    viewBox: "0 0 1366 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M805.698 18.8316L1432.18 645.3C1499.94 713.077 1499.94 822.957 1432.18 890.7L805.702 1517.18C737.956 1584.94 628.076 1584.94 560.296 1517.18L-66.1621 890.706C-133.945 822.959 -133.945 713.075 -66.1676 645.297L560.296 18.8333C628.074 -48.9441 737.958 -48.9441 805.698 18.8316ZM495.05 1060.38L388.066 1167.36L649.097 1428.37L651.225 1430.38C669.306 1446.41 696.592 1446.44 714.706 1430.46L716.921 1428.38L789.966 1355.3L495.05 1060.38ZM698.648 856.77L583.854 971.574L878.767 1266.49L993.571 1151.69L698.648 856.77ZM184.477 963.756L878.769 269.465L993.574 384.271L299.281 1078.55L184.477 963.756ZM1082.35 473.054L787.443 767.978L1082.36 1062.89L1343.38 801.925C1361.41 783.876 1362.08 755.036 1345.39 736.213L1343.39 734.087L1082.35 473.054ZM789.96 180.667L716.93 107.637C698.881 89.5969 670.059 88.9287 651.224 105.628L649.097 107.632L22.6276 734.101C4.59798 752.122 3.93022 780.953 20.6289 799.796L22.6327 801.925L95.6677 874.96L789.96 180.667Z",
    fill: "#F8F8F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombined);
export default __webpack_public_path__ + "static/media/combined.fb9b59fb7ef111c7ecef4e7db4eab24a.svg";
export { ForwardRef as ReactComponent };